import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
} from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';

export const AuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return true;
  }

  //toastr.error("You don't have permission.");
  router.navigate(['login']);

  return false;
};

export const UserGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const toastr = inject(ToastrService);

  if (!authService.isBpsAdmin()) {
    return true;
  }

  toastr.error("You don't have permission.");
  authService.logout();

  return false;
};

export const BpsAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const toastr = inject(ToastrService);

  if (authService.isBpsAdmin()) {
    return true;
  }

  toastr.error("You don't have permission.");
  authService.logout();

  return false;
};

export const PermissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const authService = inject(AuthService);
  const toastr = inject(ToastrService);
  const router = inject(Router);
  const requiredPermission = route.data['requiredPermission']; // Get permission from route data

  if (authService.isBpsAdmin()) {
    authService.logout()
  }

  if (requiredPermission && authService.isAuthorized(requiredPermission)) {
    return true;
  } else {
    const parentChildren = route.parent?.routeConfig?.children;
    const parentPath= getParentPaths(route);

    if (parentChildren) {
      for (const child of parentChildren) {
        const childPermission = child.data?.['requiredPermission'];
        const childPath = child.path;

        if (childPermission && authService.isAuthorized(childPermission)) {
          router.navigate([`/${parentPath}/${childPath}`]);
          return true;
        }
      }
    }
  }

  toastr.error("You don't have permission to access this route.");

  if (router.url === '/') router.navigate(['/']);
  return false;
};

function getParentPaths(route: ActivatedRouteSnapshot): string {
  const paths: string[] = [];

  let current = route.parent;
  while (current) {
    const pathSegment = current.routeConfig?.path;
    if (pathSegment && pathSegment !== '') {
      paths.unshift(pathSegment);
    }
    current = current.parent;
  }

  return paths.join('/') + '/';
}
